import React from 'react';
import { FileText, Calculator, Clock, Shield as ShieldIcon, TrendingUp as TrendingUpIcon, Heart,Building } from 'lucide-react';

const CategoryInfoSection = ({ selectedCategory, currentCategory }) => {
  const categoryInfo = {
  'study-funds': {
    title: 'קרן השתלמות – החיסכון היחיד שגם פטור ממס וגם נזיל',
    subtitle: 'קרן השתלמות היא אפיק חיסכון והשקעה ייחודי ופטור ממס, שנולד במקור למימון השתלמות מקצועית – אך הפך לאחד הכלים הפיננסיים החזקים ביותר בישראל עבור שכירים ועצמאים כאחד. מדובר במוצר נזיל יחסית, עם פוטנציאל צבירה גבוה, גמישות רבה ויתרונות מס שאין בשום אפיק אחר.',
    icon: FileText,
    sections: [
      {
        title: '💡 למה קרן ההשתלמות כל כך חזקה?',
        content: `
        • **פטור ממס רווחי הון** – לאחר 6 שנות חיסכון, ניתן למשוך את הכסף כולו בפטור מלא ממס רווחי הון (25%)
        • **נזילות מלאה לאחר התקופה** – הכסף זמין לשימוש חופשי לכל מטרה
        • **תשואות מצטברות** – בהתאם למסלול ההשקעה, ניתן ליהנות מהשפעת הריבית־דריבית לאורך זמן
        • **דמי ניהול נמוכים יחסית** – במיוחד במסלולים פופולריים ובגופים גדולים
        • **יכולת מעבר בין מסלולי השקעה** באותו גוף – ניתן לשנות מסלול השקעה בכל זמן, ללא אירוע מס או קנס
        • **יכולת מעבר בין גופים שונים** (יצרנים) – ניתן לנייד את הקרן לגוף מנהל אחר, לשפר תשואות או להפחית דמי ניהול – ללא אירוע מס וללא פגיעה בוותק שנצבר`
      },
      {
        title: '💰 מבנה ההפקדות',
        content: `
        **לשכירים:**
        • המעסיק מפקיד עד 7.5% מהשכר
        • העובד מפקיד 2.5% מהשכר
        • ההפקדות פטורות ממס עד התקרה הקבועה בחוק
        
        **לעצמאים:**
        • ניתן להפקיד עד כ־4.5% מההכנסה השנתית
        • עד תקרה של כ־20,820 ₪ (נכון ל־2025)
        • לקבל הטבת מס`
      },
      {
        title: '✅ יתרונות מרכזיים (כולל כאלה שפחות מדברים עליהם)',
        content: `
        • **פטור ממס רווחי הון** – אחרי 6 שנים (או 3 שנים להשתלמות מקצועית), הרווחים פטורים לחלוטין ממס
        • **אפיק מימון נוח** – אפשרות לקבל הלוואות על חשבון הקרן בריבית נמוכה בהרבה מהבנקים
        • **גמישות השקעה** – מעבר בין מסלולים ובין גופים ללא אירוע מס
        • **פיזור השקעות רחב** – בחירה בין מסלולים עם רמות סיכון שונות, כולל מנייתי, כללי, אג"ח, מדדי חו"ל ועוד
        • **שינוי אסטרטגיית השקעה בהתאם לשוק** – בלי לשלם מס או קנסות`
      },
      {
        title: '⚠️ חסרונות שחשוב להכיר',
        content: `
        • **אין תשואה מובטחת** – התשואה תלויה בביצועי השוק ובמסלול ההשקעה
        • **שבירת הקרן לפני המועד** – כרוכה בחבות מס על הרווחים, שעשויה להיות גבוהה
        • **השקעה בשוק ההון** – קיימת תנודתיות בהתאם למסלול
        • **דמי ניהול משתנים** – יש לבדוק ולהשוות בין גופים`
      },
      {
        title: '📊 מסלולי השקעה נפוצים',
        content: `
        **כללי** - פיזור בין מניות ואג"ח, איזון בין סיכון לתשואה
        
        **אג"ח מדינה** - חשיפה נמוכה למניות, תנודתיות נמוכה
        
        **מנייתי** - חשיפה של עד 100% למניות
        
        **מדדי חו"ל** - השקעה במדדים בינלאומיים מובילים
        
        **פסיביים על מדדים** - מסלולים שעוקבים אחרי מדדי מניות גדולים כגון S&P 500, מדדי תל אביב ומדדים עולמיים נוספים, במטרה לשקף את ביצועי השוק ללא ניהול אקטיבי
        
        **הלכה / שריעה** - השקעות בהתאם לכללי ההלכה היהודית והאסלאמית`
      },
      {
        title: '🎯 למי זה מתאים?',
        content: `
        • **לשכירים** שמעוניינים בחיסכון פטור ממס ונזיל לאחר 6 שנים
        • **לעצמאים** שמעוניינים בהטבות מס ובאפיק השקעה נזיל
        • **למי שמחפש הלוואות זולות** במיוחד בתנאים אטרקטיביים`
      },
      {
        title: '⏳ מתי אפשר למשוך את הכסף?',
        content: `
        • **לאחר 6 שנים** – לכל מטרה, ללא מס
        • **לאחר 3 שנים** – למטרת השתלמות מקצועית בלבד, עם אישורים מתאימים
        • **לאחר 3 שנים** – אם פתחת את הקרן לאחר גיל 60, ניתן למשוך את הכספים לכל מטרה ללא מס`
      },
      {
        title: '🏦 תנאי הלוואה על חשבון הקרן',
        content: `
        **על כספים נזילים** – פריים מינוס 0.5%, ובחלק מהגופים אפילו פריים מינוס 0.75%
        
        **על כספים לא נזילים** – לרוב פריים פלוס 0.5% עד פריים פלוס 1%
        
        **שיעור ההלוואה** – עד 80% מהיתרה בקרן הנזילה, ועד 50% מהיתרה בקרן הלא נזילה
        
        **סוגי ההחזר** – שפיצר, גרייס, או בלון (תשלום הקרן והריבית בסוף)`
      },
      {
        title: '📝 סיכום',
        content: 'קרן השתלמות היא האפיק היחיד בישראל שמשלב חיסכון לטווח בינוני, פטור ממס רווחי הון, נזילות מלאה, דמי ניהול תחרותיים, גמישות בהשקעה, והיכולת לנייד או לשנות מסלול בכל עת – ללא אירוע מס. היא מתאימה כמעט לכל חוסך, ומהווה כלי מצוין הן לצבירת הון והן לקבלת הלוואות בתנאים אטרקטיביים במיוחד.'
      }
    ]
  },
'pension-savings': {
    title: 'קופת גמל – החיסכון לטווח ארוך עם גמישות וניידות מלאה',
    subtitle: 'קופת גמל היא אחד מאפיקי החיסכון הפנסיוניים המרכזיים בישראל, המיועדת לצבירת כספים לקצבה חודשית או לסכום חד פעמי בפרישה – בהתאם לתקנות משרד האוצר. הכספים מושקעים בשוק ההון במסלולי השקעה שונים, שניתן לבחור ולשנות בהתאם להעדפות החוסך, רמת הסיכון והמטרות הכלכליות.\n\nקופת גמל מתאימה הן לשכירים והן לעצמאים, ויכולה לשמש כחיסכון פנסיוני עיקרי או משלים. היא מציעה יתרונות משמעותיים כמו ניהול השקעות מקצועי, הטבות מס, אפשרות מעבר בין מסלולים ובין גופים ללא אירוע מס, וגמישות בבחירת רמת הסיכון.',
    icon: Calculator,
    sections: [
      {
        title: '💡 קופת גמל – מה זה בעצם?',
        content: 'קופת גמל היא מכשיר חיסכון פנסיוני, שבו הכספים מופקדים על ידי עובד, מעסיק או עצמאי, ומנוהלים על ידי גוף מוסדי – חברת ביטוח או בית השקעות. הכספים מושקעים בשוק ההון במסלולים שניתן לבחור, והמטרה היא להבטיח הכנסה חודשית בפרישה או סכום חד פעמי בהתאם לכללים.'
      },
      {
        title: '📅 מבנה הקופות – מה קיים בפנים?',
        content: `
        **1. קופות חדשות (מ־2008 והלאה):**
        • מוגדרת כקופה קצבתית בלבד
        • לא ניתן למשוך כספים כסכום חד פעמי, אלא כקצבה חודשית החל מגיל 60 ובכפוף לתנאים
        • נועדה להבטיח הכנסה חודשית קבועה בפרישה
        
        **2. קופות ותיקות (לפני 2008):**
        • הכספים נזילים כ"הוני" לאחר גיל 60 (ולעיתים גם קודם, אם עברו 15 שנים ויותר)
        • מדובר ברכיב הוני – ניתן למשוך לכל מטרה
        • פטור חלקי ממס בהתאם לחוק`
      },
      {
        title: '💰 מבנה ההפקדות',
        content: `
        **שכירים** – ההפקדות נעשות על ידי המעסיק והעובד, כחלק מהפרשות הפנסיה, בהתאם לחוק
        
        **עצמאים** – יכולים להפקיד באופן עצמאי לקופת גמל ולהנות מהטבות מס על פי מגבלות החוק
        
        **העברות** – קיימת אפשרות להעברת כספים מקופות גמל אחרות, קרנות פנסיה או ביטוחי מנהלים – בהתאם לכללי הניוד`
      },
      {
        title: '✅ יתרונות מרכזיים',
        content: `
        • **ניהול מקצועי של ההשקעות** – ניהול הכספים על ידי מנהלי השקעות מקצועיים בעלי ניסיון בשוק ההון
        • **הטבות מס** – הפקדות לקופת גמל מקנות זכאות להטבות מס, בהתאם לתקרות שנקבעו בחוק
        • **מעבר בין מסלולי השקעה** – ניתן לשנות את מסלול ההשקעה בכל עת, ללא אירוע מס או קנס
        • **מעבר בין גופים מנהלים** – ניתן לנייד את הקופה בין גופים שונים (בתי השקעות וחברות ביטוח) ללא תשלום מס וללא פגיעה בוותק
        • **התאמת רמת הסיכון** – בחירה בין מסלולים סולידיים, כלליים או מנייתיים, בהתאם לפרופיל האישי ולשלב החיים
        • **פיזור השקעות רחב** – השקעה במגוון אפיקים: מניות, אג"ח, מדדי חו"ל, השקעות אלטרנטיביות ועוד
        • **שקיפות מלאה** – ניתן לעקוב אחרי ביצועי הקופה, דמי הניהול והרכב ההשקעות בכל זמן
        • **אפשרות לנייד כספים** ממכשירים פנסיוניים אחרים – בהתאם לרגולציה, לשיפור תנאים או תשואות`
      },
      {
        title: '💡 תיקון 190 – השקעה מס מועדפת',
        content: `
        תיקון 190 לפקודת מס הכנסה מאפשר להפקיד סכומים לקופת גמל בתנאים ייחודיים לחוסכים מעל גיל 60 שיש להם פנסיה חודשית מינימלית (לפי החוק).
        
        • **במקרה שהעמית נפטר לפני גיל 75** – כל המוטבים מקבלים את הכספים בפטור מלא ממס רווחי הון
        • **במקרה שהעמית נפטר לאחר גיל 75** – המוטבים "נכנסים לנעליו" וממשיכים ליהנות מאותם תנאים
        
        המוצר נועד להטבה במס במעבר בין-דורי של ההון, לצד גמישות בניהול הכספים.`
      },
      {
        title: '⚠️ חסרונות שחשוב להכיר',
        content: `
        • **אין תשואה מובטחת** – התשואה תלויה בביצועי השוק ובמסלול ההשקעה
        • **הכספים מיועדים לטווח ארוך** – משיכה לפני גיל פרישה כרוכה במס גבוה
        • **חשיפה לשוק ההון** – תנודתיות והשפעה של מצבי שוק על ערך הקופה
        • **דמי ניהול משתנים** – יש לבדוק ולהשוות בין גופים ומסלולים`
      },
      {
        title: '📊 סוגי מסלולי השקעה עיקריים',
        content: `
        **כללי** - פיזור בין מניות ואג"ח, איזון בין סיכון לתשואה
        
        **אג"ח מדינה / אג"ח כללי** - חשיפה נמוכה למניות, יציבות גבוהה יותר
        
        **מנייתי** - חשיפה של עד 100% למניות, מיועד לחוסכים עם אופק השקעה ארוך
        
        **מדדי חו"ל** - השקעה במדדים בינלאומיים גדולים
        
        **פסיביים על מדדים** - מסלולים שעוקבים אחרי מדדי מניות מובילים כגון S&P 500, מדדי תל אביב ומדדים עולמיים נוספים
        
        **הלכה / שריעה** - השקעות בהתאם לכללי ההלכה היהודית והאסלאמית
        
        **מסלול מותאם גיל** - התאמת רמת הסיכון לגיל החוסך, עם הקטנת החשיפה למניות ככל שמתקרבים לפרישה`
      },
      {
        title: '💰 דמי ניהול והוצאות',
        content: 'בקופות גמל יש 2 סוגי עלויות עיקריות: דמי ניהול מצבירה (נגבים כאחוז מהיתרה) ודמי ניהול מהפקדה (נגבים כאחוז מההפקדה החודשית). בנוסף קיימות לעיתים הוצאות ניהול השקעות פנימיות. ב"גמל נט AI" מוצג גם החישוב בפועל – כולל כלל ההוצאות האמיתיות שנגבו בפועל בקופה.'
      }
    ]
  },
  'pension-plans': {
    title: 'קרן פנסיה – הקונסנזוס הפנסיוני של ישראל',
    subtitle: 'קרן פנסיה היא מכשיר החיסכון הפנסיוני המרכזי בישראל לגיל פרישה, ונחשבת לסטנדרט ברירת המחדל עבור רוב הציבור. היא משלבת חיסכון לטווח ארוך עם רכיבי ביטוח למקרה נכות או פטירה, ומתנהלת במודל של ערבות הדדית בין העמיתים.',
    icon: Clock,
    sections: [
      {
        title: '🏛️ מה הופך אותה למובילה?',
        content: `
        • **דמי ניהול מהנמוכים בשוק**
        • **כיסוי ביטוחי מובנה** לנכות ולשארים
        • **מסלולי השקעה מותאמים** לפי גיל
        • **אפשרות ניוד חופשית** בין גופים
        • **פיקוח הדוק** של רשות שוק ההון
        
        כיום, קרן הפנסיה היא לא רק חובה חוקית – אלא ברירת המחדל הכלכלית החכמה ביותר לרוב המוחלט של החוסכים.`
      },
      {
        title: '📋 סוגי קרנות פנסיה',
        content: `
        **🏛 קרנות פנסיה ותיקות (לפני 1.3.1995):**
        • קרנות סגורות למצטרפים חדשים
        • פנסיה מוגדרת מראש (Defined Benefit)
        • הבטחת איזון אקטוארי על ידי המדינה ("הסדר הקיבוע")
        • אין ניוד בין גופים, זכויות תלויות בוותק ושכר ממוצע
        
        **📘 קרנות פנסיה חדשות (משנת 1995 והלאה):**
        • פתוחות לציבור הרחב
        • ניהול מבוסס על צבירה, תשואות ודמי ניהול
        • ככל שמפקידים יותר – כך הקצבה גבוהה יותר
        • השקעה לפי מסלול שנבחר, התאמה אוטומטית לפי גיל
        • בין 30% ל-60% מהנכסים (בהתאם לגיל) מושקעים באג"ח מיועדות בערבות המדינה עם תשואה מובטחת
        • יתרת הכספים מושקעת בשוק ההון בהתאם למסלול שנבחר`
      },
      {
        title: '💰 רכיבי ההפקדה',
        content: `
        **שכירים:**
        • תגמולי עובד: 6% מהשכר (מפקיד העובד)
        • תגמולי מעסיק: 6.5%-7.5% מהשכר (מפקיד המעסיק)
        • רכיב פיצויים: עד 8.33% מהשכר (מפקיד המעסיק)
        
        **עצמאים:**
        • יכולים להפקיד עד 16.5% מהכנסה מוכרת
        • ניכוי בגין חלק מההפקדה
        • זיכוי בגין רכיב נוסף לפי הכנסה
        
        **תקרות הפקדה לשנת 2025:**
        • שכיר: עד כ-2,760 ₪ לחודש מזכה בהטבות מס (מעסיק + עובד)
        • עצמאי: עד כ-35,760 ₪ בשנה מזכה בהטבות מס
        • שכיר בעל שליטה: לפי כללי מס הכנסה ובכפוף למגבלות נוספות`
      },
      {
        title: '🛡️ ביטוח מובנה',
        content: `
        קרן פנסיה כוללת כיסוי ביטוחי אוטומטי (למעט במסלולים ייעודיים ללא ביטוח):
        
        • **ביטוח נכות** (אובדן כושר עבודה): קצבה חודשית למבוטח
        • **ביטוח שארים**: קצבה לבן/בת הזוג ולילדים במקרה פטירה
        
        ניתן לבחור במסלולים מותאמים – לדוגמה, ללא שארים, ללא כיסוי לנכות, או מסלולי בריאות לקויה.`
      },
      {
        title: '🎯 קרנות ברירת מחדל',
        content: 'משרד האוצר מינה קרנות ברירת מחדל במכרז תחרותי – המספקות תנאים משופרים ודמי ניהול מוזלים: אלטשולר שחם, מיטב דש, מור וגופים נוספים. חוסך שלא בחר קרן בעצמו – יועבר אוטומטית לאחת מהן. ב-2016 השיק משרד האוצר את מודל פנסיית ברירת המחדל – מהלך שהכניס גם בתי השקעות לתחום קרנות הפנסיה, לצד חברות הביטוח, והציב דמי ניהול מסובסדים ומפוקחים לתקופה ארוכה.'
      },
      {
        title: '✅ יתרונות בולטים',
        content: `
        • **דמי ניהול נמוכים** – במיוחד בקרנות ברירת מחדל
        • **הטבות מס** לעצמאים ושכירים
        • **ניוד חופשי** בין גופים ומסלולים
        • **הגנה ביטוחית מלאה** כחלק מהחיסכון
        • **תשתית מצוינת** לקיבוע זכויות ופטור ממס בגיל פרישה
        • **חיסכון חובה לכל עובד** – מבטיח צבירת זכויות פנסיוניות
        • **תשואה מובטחת על חלק מהחיסכון** דרך אג"ח מיועדות בערבות מדינה
        • **פיקוח צמוד** של רשות שוק ההון`
      },
      {
        title: '⚠️ חסרונות אפשריים',
        content: `
        • **אין אפשרות למשוך כספים לפני גיל פרישה** (למעט מקרים חריגים)
        • **הקצבה תלויה בתשואות ובמקדם ההמרה** – אינה מובטחת מראש
        • **ישנם סיכונים באיזון האקטוארי** – תמותה ונכות באוכלוסייה משפיעים על כלל החוסכים
        • **הכסף אינו נזיל לפני גיל פרישה**, למעט במקרים חריגים (כגון נכות או מוות)
        • **מודל ערבות הדדית** – הצעירים מסבסדים את המבוגרים שעדיין מושכים פנסיה עד סוף חייהם, מה שעלול ליצור גירעון אקטוארי שישפיע על יתרת החוסך
        • **לרוב הקרנות נגבים דמי ניהול מהפקדה** בנוסף לדמי ניהול מצבירה – רכיב שלא קיים בקרנות השתלמות וכמעט שלא קיים בקופות גמל`
      },
      {
        title: '📊 מסלולי השקעה עיקריים',
        content: `
        **מסלול גיל** - חוסכים שלא רוצים להתעסק: התאמה אוטומטית לפי גיל
        
        **כללי** - רוב הציבור: פיזור רחב, השקעה אחראית ומגוונת
        
        **מנייתי** - צעירים עם אופק ארוך: פוטנציאל תשואה גבוה, תנודתיות גבוהה
        
        **אג"ח** - מבוגרים, שמרנים: סיכון נמוך יותר, תשואה יציבה
        
        **הלכתי / שרעי** - לפי עקרונות דתיים: ללא ריבית או מגזרים מסוימים`
      },
      {
        title: '💡 קיבוע זכויות ומס',
        content: 'הקצבה מקרן פנסיה מוכרת לצורכי קיבוע זכויות מול מס הכנסה – תהליך המאפשר לקבל פטור חלקי ממס על הקצבה בגיל פרישה. קרן הפנסיה מהווה את הבסיס לקביעת קצבה מזכה, ומסייעת בניצול תקרות המס המקסימליות המותרות בחוק.'
      },
      {
        title: '⚠️ הערה חשובה',
        content: 'אם אתה מחזיק בקרן פנסיה שאינה פעילה כבר תקופה ואינה נמצאת ב"ריסק זמני" – סביר שהיורשים או השארים שלך לא יקבלו את יתרת הקרן באופן חד פעמי מלא במקרה מוות. לכן, במקרים כאלה כדאי לבחון העברה של הקרן לקופת גמל – בכפוף לייעוץ פרטני אצל בעל רישיון פנסיוני מוסמך.'
      }
    ]
  },
  'investment-funds': {
    title: 'קופות גמל להשקעה – נזילות מלאה עם יתרונות מס ייחודיים',
    subtitle: 'קופת גמל להשקעה הושקה בדצמבר 2016 ביוזמת שר האוצר דאז, משה כחלון, כמכשיר חיסכון חדשני וגמיש המאפשר לכל אדם לחסוך לכל מטרה – עם נזילות מלאה בכל עת, ובשונה ממכשירים פנסיוניים אחרים.',
    icon: TrendingUpIcon,
    sections: [
      {
        title: '💡 איך זה עובד?',
        content: `
        הכספים בקופה **תמיד נזילים** – ניתן למשוך אותם בכל רגע, במס של 25% מס ריאלי (לאחר קיזוז האינפלציה) בלבד על הרווחים.
        
        אבל הבונוס האמיתי מגיע אם בוחרים להמיר את הכספים לקצבה חודשית לאחר גיל 60 – אז נהנים משתי הטבות מס רדיקליות:
        
        **1️⃣ פטור מלא ממס על הרווחים** – בדומה לקרן השתלמות
        
        **2️⃣ הפנסיה החודשית פטורה ממס** ואינה נספרת בתקרות המס השולי, מה שמקטין באופן משמעותי את חבות המס על כלל הפנסיה
        
        ⚠️ **חשוב:** גם אחרי גיל 60, אם מושכים את הכספים כסכום חד־פעמי (הוני) – משלמים 25% מס רווחי הון ריאלי לאחר קיזוז האינפלציה על הרווחים.`
      },
      {
        title: '📅 תקרת הפקדה שנתית – לשנת 2026',
        content: `
        נכון לשנת 2026, ניתן להפקיד **עד 83,641 ₪ בשנה** לכל חוסך (לפי תעודת זהות).
        
        • אין מגבלה על גובה ההפקדה החודשית או החד־פעמית – כל עוד הסך הכולל לשנה אינו חוצה את התקרה השנתית של 83,641 ₪ בשנה
        • ניתן לפצל הפקדות בין כמה גופים, אך הסכום המצטבר הוא שקובע`
      },
      {
        title: '✅ יתרונות מרכזיים',
        content: `
        • **נזילות מלאה** – אפשר למשוך את הכסף בכל עת (25% מס על הרווחים)
        • **פטור ממס בקצבה לאחר גיל 60** – הפנסיה פטורה ממס ואינה נכללת במס השולי
        • **מעבר בין מסלולים וגופים ללא אירוע מס** – שומר על הוותק ומאפשר התאמת ההשקעה לשוק
        • **ניהול השקעות מקצועי** – מסלולים מגוונים: כללי, מנייתי, אג"ח, ומסלולים פסיביים על מדדים כמו S&P500, מדדי תל אביב ומדדים עולמיים
        • **אפשרות להלוואות בתנאים מועדפים** – לרוב עד 80% מהקופה ובריבית נמוכה`
      },
      {
        title: '⚠️ חסרונות שחשוב להכיר',
        content: `
        • **אין תשואה מובטחת** – התשואה תלויה בביצועי השוק
        • **מס רווחי הון של 25%** חל על כל משיכה הונית, גם אחרי גיל 60
        • **תנודתיות בשוק ההון** עלולה להשפיע על שווי הקופה
        • **דמי ניהול משתנים** – חשוב להשוות בין גופים`
      },
      {
        title: '📊 סוגי מסלולי השקעה נפוצים',
        content: `
        **כללי** - פיזור בין מניות, אג"ח ונכסים אלטרנטיביים
        
        **אג"ח / סולידי** - תנודתיות נמוכה, מתאים לטווח קצר־בינוני
        
        **מנייתי** - פוטנציאל תשואה גבוה לטווח ארוך, תנודתיות גבוהה
        
        **פסיבי על מדדים** - מסלולים שעוקבים אחרי מדדים מובילים כגון S&P500, מדדי תל אביב ומדדים עולמיים`
      },
      {
        title: '⏳ מתי אפשר למשוך את הכסף?',
        content: `
        **בכל עת** – מס של 25% על הרווחים
        
        **לאחר גיל 60:**
        • **כסכום חד־פעמי** – מס של 25% על הרווחים
        • **כקצבה חודשית** – פטור מלא ממס רווחי הון והכנסה, ואינה נכללת במס השולי`
      },
      {
        title: '📝 סיכום',
        content: 'קופת גמל להשקעה היא מוצר חיסכון דינמי וגמיש, עם יתרונות מס ייחודיים, במיוחד בהמרה לקצבה אחרי גיל 60. היא מאפשרת מעבר חופשי בין מסלולים וגופים ללא אירוע מס, ושומרת את תשלום המס ליום הפדיון בלבד – גם אם בוצעו שינויים במהלך הדרך. עובדה זו הופכת אותה לעדיפה מבחינה מיסויית על קרנות נאמנות בנקאיות, שבהן כל פעולה יוצרת אירוע מס. כאן, החיסכון יכול להמשיך לצבור תשואה על כל הסכום, ללא ניכוי מס עד למשיכה בפועל.'
      }
    ]
  },
  'insurance-savings': {
    title: 'פוליסות חיסכון פיננסיות – השקעה חכמה עם ערך מוסף גבוה',
    subtitle: 'פוליסת חיסכון פיננסית היא אחד המוצרים הגמישים והמעניינים ביותר בשוק ההשקעות בישראל. היא מנוהלת על ידי חברות הביטוח או על ידי בתי השקעות דרך פלטפורמה של חברת ביטוח, ומהווה חלופה מתקדמת לפיקדונות בנקאיים, קרנות כספיות, קרנות נאמנות ומכשירי השקעה בנקאיים.',
    icon: ShieldIcon,
    sections: [
      {
        title: '🧩 אופי המוצר',
        content: `
        • **אין מינימום הפקדה ואין תקרת הפקדה** – כל חוסך יכול להתאים את הסכומים ליכולתו ולצרכיו
        • **גמישות מוחלטת בהפקדות** – הפקדות חד פעמיות או חודשיות, בכל סכום שיבחר החוסך
        • **ניהול מקצועי** בידי מנהלי השקעות מנוסים, עם פיזור רחב בין מניות, אג"ח, נדל"ן והשקעות אלטרנטיביות
        • **מעבר חופשי בין מסלולי השקעה פנימיים** (למשל מכללי למנייתי) – ללא אירוע מס וללא עמלות
        • **ניוד בין חברות ביטוח** – אפשרות לעבור בין פוליסות של גופים שונים בלי לשלם מס
        • **פיקוח ושקיפות** – בפיקוח רשות שוק ההון, ביטוח וחיסכון`
      },
      {
        title: '💡 היתרון המיסויי',
        content: 'דחיית אירוע מס במעבר בין מסלולים או בין גופים, ללא צורך בתשלום עמלות קנייה ומכירה – בניגוד לחלק ניכר מהמכשירים הבנקאיים.'
      },
      {
        title: '✅ יתרונות מרכזיים',
        content: `
        • **דחיית מס עד הפדיון** – מס רווחי הון של 25% מס ריאלי בניכוי האינפלציה משולם רק בעת משיכת הכסף, מה שמאפשר אפקט "ריבית דריבית" על כל הרווחים
        • **חיסכון בעמלות** – מעבר בין מסלולים פנימיים או בין חברות אינו כרוך בעמלות קנייה/מכירה, בניגוד לחלק ניכר מהמכשירים הבנקאיים
        • **נזילות גבוהה** – משיכה בכל עת, כסכום חד פעמי או בפריסה
        • **גמישות השקעתית** – מגוון רחב של מסלולי השקעה בכל רמות הסיכון
        • **ניהול מקצועי עם פיקוח הדוק** – המנהלים פועלים בשקיפות ומחויבים לדיווח שוטף על ביצועי ההשקעה
        • **יכולת למנות מוטבים** – קביעת מוטבים שיקבלו את יתרת הפוליסה במקרה פטירה, בקלות וללא צורך בהליך משפטי מורכב`
      },
      {
        title: '⚠️ חסרונות שיש לקחת בחשבון',
        content: `
        • **אין הטבת מס על ההפקדה** (בניגוד לקרן פנסיה, קופת גמל או קרן השתלמות)
        • **מס רווחי הון של 25%** מס ריאלי בניכוי האינפלציה חל ביום הפדיון
        • **דמי ניהול לעיתים גבוהים יותר** מהשקעה עצמאית בקרנות סל
        • **התשואה אינה מובטחת** ותלויה בשוק`
      },
      {
        title: '📊 מסלולי השקעה נפוצים בפוליסות חיסכון',
        content: `
        **כללי** - פיזור רחב בין מניות, אג"ח, נדל"ן ואפיקים נוספים
        
        **מנייתי** - חשיפה גבוהה למניות בארץ ובעולם
        
        **סולידי / אג"חי** - דגש על יציבות ותנודתיות נמוכה
        
        **אלטרנטיבי** - השקעות לא סחירות כמו נדל"ן ותשתיות
        
        **צמוד מט"ח** - חשיפה למטבעות זרים
        
        **הלכה** - השקעות כשרות בלבד, ללא ריבית`
      },
      {
        title: '🎯 מי מתאים לפוליסה פיננסית?',
        content: `
        • **חוסכים שרוצים מוצר נזיל וגמיש** עם פוטנציאל תשואה גבוה
        • **משקיעים שמחפשים חלופה לפיקדונות ולקרנות כספיות** עם אפשרות לשינויים חופשיים ללא מס
        • **מי שמעוניין בניהול מקצועי** ולא רוצה לנהל את ההשקעה בעצמו`
      },
      {
        title: '📝 סיכום',
        content: 'פוליסת חיסכון פיננסית היא מוצר עם ערך מוסף גבוה – בזכות דחיית אירוע המס, החיסכון בעמלות, הגמישות בהשקעה, היכולת למנות מוטבים והניהול המקצועי. היא עדיפה מבחינה מיסויית על פני חלק ניכר מהמכשירים הבנקאיים – בשל העובדה שאין אירועי מס בין שינויים פנימיים או במעבר בין גופים, והמס משולם רק ביום הפדיון. כך החוסך נהנה מהמשך צבירת רווחים על כל ההון – מבלי לשלם מס בכל שלב בדרך.'
      }
    ]
  },
  'insurance-management': {
  title: 'קרנות ביטוח מנהלים – השקעות מקצועיות בניהול חברות ביטוח',
  subtitle: 'קרנות ביטוח מנהלים הן מכשירי השקעה המנוהלים על ידי חברות הביטוח, המיועדים בעיקר למשקיעים מוסדיים ופרטיים המחפשים ניהול השקעות מקצועי עם פיזור סיכונים. בניגוד לפוליסות החיסכון, קרנות אלה מתמקדות בהשקעות טהורות עם דגש על תשואות גבוהות וניהול אקטיבי.',
  icon: Building,
  sections: [
    {
      title: 'מה מייחד קרנות ביטוח מנהלים?',
      content: `
      • **ניהול מקצועי מתקדם** – חברות הביטוח משקיעות במנהלי השקעות ובכלים אנליטיים מתקדמים
      • **פיזור השקעות רחב** – השקעה במגוון אפיקים: מניות, אג"ח, נדל"ן, השקעות אלטרנטיביות
      • **יעד תשואות גבוהות** – מתמחות בהשגת תשואות עליונות לטווח הארוך
      • **גמישות בניהול** – יכולת להתאים את ההשקעות לתנאי השוק המשתנים`
    },
    {
      title: 'יתרונות מרכזיים',
      content: `
      • **מומחיות ביטוחית** – ניסיון רב שנים של חברות הביטוח בניהול סיכונים
      • **משאבים נרחבים** – יכולת השקעה במחקר ופיתוח אסטרטגיות השקעה
      • **פיקוח מוסדי** – פיקוח הדוק של רשות שוק ההון על פעילות ההשקעה
      • **ניהול מקצועי** – צוותי השקעה מנוסים עם כלים אנליטיים מתקדמים`
    },
    {
      title: 'מסלולי השקעה נפוצים',
      content: `
      **כללי** - פיזור מאוזן בין מניות, אג"ח ואפיקים נוספים
      
      **מנייתי** - התמחות במניות בארץ ובעולם
      
      **אג"חי** - התמחות באגרות חוב וכלים בעלי תשואה קבועה
      
      **מותאם גיל** - התאמת רמת הסיכון לפי הגיל והאופק ההשקעתי`
    },
    {
      title: 'לאיזה משקיעים זה מתאים?',
      content: `
      • **משקיעים מוסדיים** המחפשים ניהול מקצועי וביצועים עליונים
      • **משקיעים פרטיים** המעוניינים בהשקעה מקצועית עם פיקוח מוסדי
      • **מי שמחפש חלופה** לקרנות נאמנות או מוצרי השקעה בנקאיים
      • **משקיעים עם אופק זמן בינוני עד ארוך** המוכנים לקבל תנודתיות`
    },
    {
      title: 'סיכום',
      content: 'קרנות ביטוח מנהלים מציעות גישה מקצועית להשקעה עם ניצול היתרונות של חברות הביטוח בניהול סיכונים ובניתוח שווקים. הן מתאימות למשקיעים המחפשים ניהול אקטיבי וביצועים עליונים תחת פיקוח מוסדי הדוק.'
    }
  ]
},
  'child-savings': {
    title: 'חיסכון לכל ילד – מתנה מהמדינה עם כוח צבירה חכם',
    subtitle: '"חיסכון לכל ילד" הוא תוכנית ממשלתית שמופעלת על ידי משרד האוצר וביטוח לאומי, במטרה להבטיח הון התחלתי לכל ילד בישראל בגיל הבגרות. התוכנית פועלת באופן אוטומטי לכל ילד שנולד או עלה לישראל, והחיסכון נמשך עד גיל 18 – עם אפשרות להמשך הפקדה עד גיל 21.',
    icon: Heart,
    sections: [
      {
        title: '🧩 איך זה עובד?',
        content: `
        **הפקדת ביטוח לאומי** – המדינה מפקידה 50 ₪ בכל חודש לכל ילד עד גיל 18
        
        **הפקדת הורה** – ניתן להכפיל את ההפקדה ע"י הפניית עוד 50 ₪ מקצבת הילדים
        
        **סה"כ הפקדה אפשרית** – 100 ₪ בחודש (50 ₪ מהמדינה + 50 ₪ מההורה)`
      },
      {
        title: '📊 מסלולי ההשקעה האפשריים',
        content: `
        ניתן לבחור להשקיע את הכסף דרך הבנק או דרך בית השקעות (ניהול בשוק ההון).
        
        **על פי ההיסטוריה** – ברוב השנים בתי ההשקעות הניבו תשואות גבוהות יותר מהבנקים.
        
        **מסלולים לבחירה:**
        
        **1. סיכון מוגבר** – חשיפה גבוהה למניות, פוטנציאל תשואה גבוה לצד תנודתיות גבוהה
        
        **2. סיכון בינוני** – פיזור בין מניות לאג"ח, איזון בין סיכון לרווחיות
        
        **3. סיכון מועט** – חשיפה נמוכה למניות, דגש על יציבות
        
        **4. מסלול הלכה** – ניהול השקעות בהתאם לכללי ההלכה היהודית
        
        **5. מסלול שריעה** – ניהול השקעות בהתאם לכללי השריעה האסלאמית`
      },
      {
        title: '💡 יתרונות המוצר',
        content: `
        • **ניהול ע"י בנקים או בתי השקעות** (עם פיקוח ממשלתי)
        • **נזילות** – משיכת הכסף בגיל 18 או 21 (בהתאם להחלטת ההורה)
        • **הטבות מס** – מס רווחי הון בשיעור 25% ריאלי (בניכוי השפעת האינפלציה)
        • **דחיית מס** – אין אירוע מס במעבר בין מסלולים ובמעבר בין גופים`
      },
      {
        title: '🔗 יתרון נוסף שנוסף לאחרונה',
        content: `
        בשנה האחרונה משרד האוצר מאפשר לנו לבצע שינוי מסלול וניהול ההפקדות דיגיטלית דרך אתר ביטוח לאומי.
        
        **לביצוע שינוי חיסכון לכל ילד:**
        https://www.btl.gov.il/benefits/children/HisahoLayeled/Pages/mavar.aspx`
      },
      {
        title: '📝 סיכום',
        content: '"תוכנית חיסכון לכל ילד" היא כלי חכם לצבירת הון לילד – מתנה אמיתית ממדינת ישראל דרך משרד האוצר, שאין כנראה כמותה בשאר העולם. זו הזדמנות נדירה שחייבים לנצל בחוכמה, כדי להבטיח עתיד כלכלי טוב יותר עבור ילדינו – שהם כמובן הדבר החשוב ביותר עבורנו.'
      }
    ]
  }
};
  
    const info = categoryInfo[selectedCategory];
    if (!info) return null;
  
    const IconComponent = info.icon;
  
    return (
<section 
  className="py-16 bg-gradient-to-br from-gray-50 to-blue-50"
  style={{ 
    maxWidth: '100vw',
    overflowX: 'hidden',
    width: '100%'
  }}
>
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* כותרת ראשית */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className={`p-4 rounded-2xl ${currentCategory?.gradient ? `bg-gradient-to-r ${currentCategory.gradient}` : 'bg-blue-500'}`}>
                <IconComponent className="h-8 w-8 text-white" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {info.title}
            </h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
              {info.subtitle}
            </p>
          </div>
  
          {/* תוכן המידע */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {info.sections.map((section, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-md border border-gray-100 p-6 hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {section.title}
                </h3>
                <div className="text-gray-700 leading-relaxed">
                  {section.content.split('\n').map((paragraph, pIndex) => {
                    // טיפול בטקסט מעוצב
                    if (paragraph.trim().startsWith('**') && paragraph.trim().endsWith('**')) {
                      return (
                        <h4 key={pIndex} className="font-bold text-gray-900 mt-4 mb-2">
                          {paragraph.replace(/\*\*/g, '')}
                        </h4>
                      );
                    }
                    if (paragraph.trim().startsWith('•')) {
                      return (
                        <li key={pIndex} className="ml-4 mb-1">
                          {paragraph.replace('•', '').trim()}
                        </li>
                      );
                    }
                    if (paragraph.trim()) {
                      return (
                        <p key={pIndex} className="mb-3">
                          {paragraph}
                        </p>
                      );
                    }
                    return null;
                  })}
                </div>
              </div>
            ))}
          </div>
  
          {/* קריאה לפעולה */}
          <div className="mt-12 text-center">
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                רוצים לראות השוואה מפורטת?
              </h3>
              <p className="text-gray-600 mb-6">
                גלו איזה {currentCategory?.title?.toLowerCase()} הכי מתאימה לכם עם הכלים החכמים שלנו
              </p>
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`px-8 py-3 rounded-lg font-semibold text-white transition-colors ${
                  currentCategory?.gradient ? 
                  `bg-gradient-to-r ${currentCategory.gradient} hover:opacity-90` : 
                  'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                חזור לטבלאות ההשוואה ↑
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default CategoryInfoSection;